'use client';
import { useId } from '@s7/hooks';
import { useProps } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// TODO: возвращать кортеж из 3 элементов вместо объекта
var useInputProps = function(__ident, defaultProps, props) {
    var _useProps = useProps(__ident, defaultProps, props), _useProps_ = _useProps[0], id = _useProps_.id, label = _useProps_.label, labelProps = _useProps_.labelProps, hint = _useProps_.hint, hintProps = _useProps_.hintProps, className = _useProps_.className, style = _useProps_.style, sx = _useProps_.sx, wrapperProps = _useProps_.wrapperProps, inputContainer = _useProps_.inputContainer, elementsOrder = _useProps_.elementsOrder, labelElement = _useProps_.labelElement, states = _useProps_.states, state = _useProps_.state, disabled = _useProps_.disabled, required = _useProps_.required, sxs = _useProps[1], others = _object_without_properties_loose(_useProps[0], [
        "id",
        "label",
        "labelProps",
        "hint",
        "hintProps",
        "className",
        "style",
        "sx",
        "wrapperProps",
        "inputContainer",
        "elementsOrder",
        "labelElement",
        "states",
        "state",
        "disabled",
        "required"
    ]);
    var uid = useId(id);
    return _extends({}, others, {
        styles: sxs.styles,
        classNames: sxs.classNames,
        wrapperProps: _extends({}, sxs, {
            id: uid,
            label: label,
            labelProps: labelProps,
            hint: hint,
            hintProps: hintProps,
            className: className,
            style: style,
            sx: sx,
            inputContainer: inputContainer,
            elementsOrder: elementsOrder,
            labelElement: labelElement,
            state: state,
            states: states,
            disabled: disabled,
            required: required
        }, wrapperProps),
        inputProps: _extends({}, sxs, {
            id: uid,
            disabled: disabled,
            required: required
        })
    });
};

export { useInputProps };
